import React from "react";
import { Popover } from "antd";

export function ReportInfoIcon({ title, description, isActive }) {
  if (!description) return null;

  return (
    <Popover
      content={
        <div className="converter-testing-info-popover">
          {title ? <div className="converter-testing-info-popover-title">{title}</div> : null}
          <div className="converter-testing-info-popover-text">{description}</div>
        </div>
      }
      trigger="click"
      overlayClassName="converter-testing-info-overlay"
      placement="bottom"
    >
      <button
        type="button"
        className={`converter-testing-info-icon ${isActive ? "active" : ""}`}
        aria-label={`About ${title || "this report"}`}
        onClick={(e) => e.stopPropagation()}
      >
        <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false">
          <circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" strokeWidth="1.5" />
          <path
            fill="currentColor"
            d="M7.25 7h1.5V11h-1.5V7zm0-2.25h1.5V5.5h-1.5v-.75z"
          />
        </svg>
      </button>
    </Popover>
  );
}
